export default {

	async page_list () {

		const [ stores, company_groups ] = await Promise.all([
			Anvil.models.c_store.StoreList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		const search = new Anvil.models.Record({
			company_group_id: null
		})

		await Anvil.renderPage('/c_store/page_list', { stores, company_groups, search })
	},

	async action_refresh () {

		const [ stores, company_groups ] = await Promise.all([
			Anvil.models.c_store.StoreList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		Anvil.page.stores = stores
		Anvil.page.company_groups = company_groups
		const grid = Anvil.models.components.Grid.find('#store_grid')
		if (grid) {
			grid.list = stores
		}
	},

	async modal_edit (store_data) {

		const store = new Anvil.models.c_store.Store(store_data)

		await Anvil.modal('/c_store/modal_edit', { store })
	},

	async action_save (store) {

		// Tell the record to commit
		await store.record.commit()

		Anvil.toast.success('Elmentve', 'A telephely mentése sikeres')

		// Refresh list
		await this.action_refresh()

		// Focus on company
		const grid = Anvil.models.components.Grid.find('#store_grid')
		if (grid) {
			grid.select(grid.list.data.find(c => c.machine_id == store.machine_id), true)
		}

		return true
	},

}